import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Observable } from 'rxjs';
import packageJson from '../../../../../package.json';
import { BrandService } from '../../services/brand.service';
import { EmitterService } from '../../services/emitter.service';
import { NgClass, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, RouterLink, AsyncPipe],
})
export class FooterComponent {
  private sharedService = inject(EmitterService);
  private brandService = inject(BrandService);

  public extraFooterMargin$: Observable<boolean> = this.sharedService.extraFooterMargin;
  public currentYear: number = new Date().getFullYear();
  public readonly brand = this.brandService.getBrandResources();
  public readonly version = packageJson.version;
}
